import React, { createContext, useContext, useMemo, useState } from 'react';

export interface DataFactoryFiltersState {
  onlyActive: boolean;
  setOnlyActive: (value: boolean) => void;
}

const DEFAULT_ONLY_ACTIVE = true;
const STORAGE_KEY = 'dataFactory.onlyActive';

const DataFactoryFiltersContext = createContext<DataFactoryFiltersState | undefined>(undefined);

export const DataFactoryFiltersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [onlyActive, setOnlyActiveState] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'true') return true;
      if (stored === 'false') return false;
      return DEFAULT_ONLY_ACTIVE;
    } catch {
      return DEFAULT_ONLY_ACTIVE;
    }
  });

  const setOnlyActive = (value: boolean) => {
    setOnlyActiveState(value);
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {
      // ignore storage errors
    }
  };

  const value = useMemo<DataFactoryFiltersState>(() => ({ onlyActive, setOnlyActive }), [onlyActive]);

  return (
    <DataFactoryFiltersContext.Provider value={value}>{children}</DataFactoryFiltersContext.Provider>
  );
};

export const useDataFactoryFilters = (): DataFactoryFiltersState => {
  const ctx = useContext(DataFactoryFiltersContext);
  if (!ctx) throw new Error('useDataFactoryFilters must be used within DataFactoryFiltersProvider');
  return ctx;
};
